import { dom, library } from '@fortawesome/fontawesome-svg-core'
import {
  faApple,
  faFacebookF,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons'
import { faEnvelope as faEnvelopeRegular } from '@fortawesome/free-regular-svg-icons'
import {
  faArrowCircleLeft,
  faCheck,
  faCircleNotch,
  faEnvelope,
  faExclamationCircle,
  faLock,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faApple,
  faFacebookF,
  faGoogle,
  faEnvelope,
  faLock,
  faCheck,
  faCircleNotch,
  faExclamationCircle,
  faEnvelopeRegular,
  faArrowCircleLeft
)

dom.watch()
